import { useContext, useEffect } from 'react'
import { appContext } from '../context'
import { getOid, getUserToken } from '../utils/getUserData'
import useFetch from './useFetch'

const userToken = getUserToken()
const customerId = getOid()

const useSubmitDiscountCode = (postData: GenericObject) => {
  const context = useContext(appContext)
  const {
    response,
    loading,
    error,
    setError,
    fetchData: submitDiscountCode,
  } = useFetch({
    method: 'POST',
    url: `/basket/basket/${customerId}/discount-code`,
    headers: {
      'Authorization': `Bearer ${userToken}`,
    },
    data: postData,
  })
  
  useEffect(() => {
    if(response?.data && JSON.stringify(response?.data) !== JSON.stringify(context?.basket)) {
      const responseData: BasketType = response?.data
      context?.setBasket(responseData)
      context?.setTotalPrice(responseData?.price?.discountedPrice || responseData?.price?.totalPrice || 0)

      if (responseData?.basketId) {
        context?.setBasketIdForPay(responseData?.basketId)
      }
    }
  }, [response])

  return {
    response,
    error,
    loading,
    setError,
    submitDiscountCode,
  }
}

export default useSubmitDiscountCode
